import { FadedImage } from "../../FadedImage";

const A = "/brand";
const IMG = `${A}/blueprint4joy-consistencycorner-lacelaugh-laptop.jpg`;
const ALT = "Lara laughing warmly at her laptop in a bright kitchen during a Consistency Corner gathering.";

export function WhatConsistencyCornerIs() {
  return (
    <section data-testid="cc-what-it-is-section" className="relative overflow-hidden bg-white">
      <div className="relative w-full overflow-hidden reveal pb-[46px] lg:pb-0">
        {/* Desktop: warm connection image half-band on the left */}
        <div className="hidden lg:block absolute inset-y-0 left-0 w-[46%]">
          <FadedImage
            src={IMG}
            alt={ALT}
            testId="cc-what-it-is-image"
            bg="#FFFFFF"
            objectPosition="52% 22%"
            featherRight={46}
            featherTop={10}
            featherBottom={10}
            className="absolute inset-0"
          />
        </div>

        {/* Mobile: stacked on top */}
        <div className="lg:hidden relative w-full aspect-[4/3] mb-[30px]">
          <FadedImage
            src={IMG}
            alt={ALT}
            testId="cc-what-it-is-image-mobile"
            bg="#FFFFFF"
            objectPosition="52% 18%"
            featherBottom={20}
            className="absolute inset-0"
          />
        </div>

        <div className="relative z-[2] max-w-7xl mx-auto px-6 md:px-10 lg:min-h-[560px] flex items-center">
          <div className="w-full lg:w-1/2 lg:ml-auto lg:pl-10">
            <p className="text-xs tracking-[0.24em] uppercase text-[#159E9A] mb-5">
              A Place to Return
            </p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-[52px] leading-[1.1] tracking-tight text-[#1C1917] mb-7 max-w-lg">
              Not another program to keep up with.
            </h2>
            <div className="space-y-4 text-lg md:text-xl leading-relaxed text-[#57534E] max-w-lg">
              <p>
                Consistency Corner is a weekly check-in for people who want to
                stay connected to the work, dream, decision or change that
                matters to them.
              </p>
              <p>It isn&rsquo;t a class.</p>
              <p>There&rsquo;s no homework to fall behind on and no performance required.</p>
              <p>
                You simply arrive as you are, notice what happened during the
                week and choose what you want to carry forward.
              </p>
              <p>Some weeks you&rsquo;ll celebrate progress.</p>
              <p>Some weeks you&rsquo;ll need help beginning again.</p>
              <p className="font-display text-2xl md:text-3xl text-[#159E9A] leading-snug pt-2">
                Both count.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
